import { render } from "./AppointmentList.vue?vue&type=template&id=3fcff53f&scoped=true"
import script from "./AppointmentList.vue?vue&type=script&lang=js"
export * from "./AppointmentList.vue?vue&type=script&lang=js"

import "./AppointmentList.vue?vue&type=style&index=0&id=3fcff53f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fcff53f"]])

export default __exports__